import { render, staticRenderFns } from "./CommonModal.vue?vue&type=template&id=6b0c8d2a&scoped=true"
import script from "./CommonModal.vue?vue&type=script&lang=js"
export * from "./CommonModal.vue?vue&type=script&lang=js"
import style0 from "./CommonModal.vue?vue&type=style&index=0&id=6b0c8d2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0c8d2a",
  null
  
)

export default component.exports